import { View } from 'foundations-components/components/View';
import BrandVoiceMessage from 'ui-brand-identity-lib/components/BrandVoiceMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const BrandVoiceMessageConfig = {
  applied: {
    asPopover: true
  },
  disabled: {
    hideRefreshButton: true
  },
  setup: {
    hideRefreshButton: true
  }
};

/**
 * Wrapper around ui-brand-identity-lib BrandVoiceMessage component
 *
 * TODO: support brandVoiceSubChannel (enum)
 */
const BrandVoiceInfo = ({
  brandVoiceOptions,
  brandVoiceChannel,
  businessUnitId,
  isUngatedForCopilotV2 = false
}) => {
  // For Copilot V1 message format with a brandVoiceOptions object (missing from V2)
  if (!isUngatedForCopilotV2) {
    if (!brandVoiceOptions) {
      return null;
    }
    return /*#__PURE__*/_jsx(View, {
      marginBlockStart: "300",
      children: /*#__PURE__*/_jsx(BrandVoiceMessage, {
        brandVoiceChannel: brandVoiceOptions === null || brandVoiceOptions === void 0 ? void 0 : brandVoiceOptions.voiceChannel
        // Note: within EditorPlugin, we don't actually know if the portal has scope or not
        //       we are depending on the consumer to include or exclude brandVoiceOptions
        ,
        shouldRender: true,
        config: BrandVoiceMessageConfig,
        brandVoiceOptions: brandVoiceOptions
      })
    });
  }
  if (!brandVoiceChannel) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "300",
    children: /*#__PURE__*/_jsx(BrandVoiceMessage, {
      brandVoiceChannel: brandVoiceChannel
      // Note: within EditorPlugin, we don't actually know if the portal has scope or not
      //       we are depending on the consumer to check scopes before rendering the command
      ,
      shouldRender: !!brandVoiceChannel,
      businessUnitId: businessUnitId,
      config: BrandVoiceMessageConfig
    })
  });
};
export default BrandVoiceInfo;